import {
  ArrayOperators,
  SingleOperators,
} from 'common/src/query-params/operators';

import { CustomFilterOperator } from './CustomFilter.interface';

export const customSingleOperators: Array<CustomFilterOperator> = [
  {
    label: 'Equals',
    value: SingleOperators.EQUALS,
  },
  {
    label: 'Greather than',
    value: SingleOperators.GREATER_THAN,
  },
  {
    label: 'Greater than or equal to',
    value: SingleOperators.GREATER_THAN_OR_EQUAL_TO,
  },
  {
    label: 'Less than',
    value: SingleOperators.LESS_THAN,
  },
  {
    label: 'Less than or equal to',
    value: SingleOperators.LESS_THAN_OR_EQUAL_TO,
  },
  {
    label: 'Not equals',
    value: SingleOperators.NOT_EQUAL_TO,
  },
];

export const customArrayOperators: Array<CustomFilterOperator> = [
  {
    label: 'In',
    value: ArrayOperators.IN,
  },
];
